import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

// 基本状态
const state = {
    user: {}, //用户信息
    userAuth: {},//用户权限
    userPermissions: [],
    userInfo: {},
    routePath: null,
    routeTitle: null,
};

// 创建改变状态的方法
const mutations = {
    // 登录
    LOGIN(state, user) {
        delete user.permissions
        state.user = user;
        Vue.ls.set('user', user);
    },

    // 登出
    LOGOUT(state) {
        state.user = {};
        state.userAuth = {};
        Vue.ls.remove('user');
        Vue.ls.remove('userAuth');
    },

    // 更新
    UPDATE(state) {
        let localUser = Vue.ls.get('user');
        let localAuth = Vue.ls.get('userAuth');
        state.user = Object.assign({}, state.user, localUser);
        state.userAuth = Object.assign({}, state.userAuth, localAuth);
    },
    /**
     * @description 处理地址栏url路由
     * @param {*} state
     * @param {*} data
     */
    handleRoutePath(state, data) {
        // eslint-disable-next-line no-console
        state.routePath = data.path || ''
        state.routeTitle = data.title || ''
    },
    /**
     * @description 处理用户登录信息
     * @author YM
     * @date 2019-01-10
     * @param {*} state
     * @param {*} data
     */
    handleUserInfo(state, data) {
        state.user = data
    },
    /**
     * @description 处理用户权限信息
     * @author YM
     * @date 2019-01-10
     * @param {*} state
     * @param {*} data
     */
    handleUserPermissions(state, data) {
        state.userAuth = data;
        Vue.ls.set('userAuth', data);
        state.userPermissions = data ? Object.keys(data) : []
        Vue.ls.set('userPermissions', state.userPermissions);
    },
};

const getters = {
    // id:state=> state.user.id,
    getUser(state) {
        return state.user;
    },
    getUserAuth(state) {
        return state.userAuth;
    },
    routePath: state => state.routePath,
    routeTitle: state => state.routeTitle,
    userPermissions: state => state.userPermissions
};

// 创建驱动actions可以使得mutations得以启动
const actions = {
    login({commit}, user) {
        commit('LOGIN', user);
    },
    logout({commit}) {
        commit('LOGOUT');
    },
    update({commit}) {
        commit('UPDATE');
    },
    handlePermissions({commit}, permissions) {
        commit('handleUserPermissions', permissions)
    }
};

export default new Vuex.Store({
    state,
    actions,
    getters,
    mutations
});
